import React, { useEffect, useState } from "react";
import { Box, Paper, CircularProgress, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataTable } from "../../components/DataTable";
import { toast, ToastContainer } from "react-toastify";
import { getUserInfo } from "../../utils/user.util";
import { PageHeader } from "../../components/PageHeader";
import { getColumns } from "./getColumns";
import { usePagination } from "./usePagination";
import { useApiFeedback } from "./useApiFeedback";
import { ApiDelete } from "../../helpers/API/ApiData";
import { usePermissions } from "../../hooks/usePermissions";

const Rate = () => {
  const { canDelete } = usePermissions("/rating");
  const { page, setPage, count, setCount, countPerPage, setCountPerPage } =
    usePagination({ initialPage: 1, initialPerPage: 10 });

  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [ratingIdForDelete, setRatingIdForDelete] = useState<string>("");

  const userInfo = getUserInfo();

  const { loading, data, fetchFeedback } = useApiFeedback({
    userId: userInfo?.id,
    search,
    page,
    countPerPage,
    setCount,
  });

  useEffect(() => {
    fetchFeedback();
  }, [search, page, countPerPage, fetchFeedback]);

  const deleteRatingDetail = async () => {
    try {
      await ApiDelete(`rating/delete?id=${ratingIdForDelete}`);
      toast.success("Umfragen erfolgreich löschen");
      setShow(false);
      fetchFeedback();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen. Bitte versuche es erneut");
    }
  };

  const deleteRatingClickHandler = ({ row }: { row: any }) => {
    setRatingIdForDelete(row?._id);
    setShow(true);
  };


  const columns = getColumns({ deleteRatingClickHandler, canDelete });

  return (
    <>
      <ToastContainer />
      <Paper sx={{ p: 1 }}>
        <Box sx={{ p: 2, mb: 2 }}>
          <PageHeader title="App Bewertungen" onSearch={(val) => { setSearch(val); setPage(1); }} />

          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}>
              <CircularProgress />
            </Box>
          ) : (
            <DataTable
              rows={data as any[] || []}
              columns={columns}
              getRowId={(row: any) => row._id}
              page={page}
              count={count}
              rowsPerPage={countPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setCountPerPage}
              rowsPerPageOptions={[10, 20, 25, 50, 100]}
            />
          )}
        </Box>
      </Paper>
      <Dialog open={show} onClose={() => setShow(false)}>
        <DialogTitle sx={{ color: "error.main", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Löschen bestätigen
          <IconButton size="small" onClick={() => setShow(false)} aria-label="close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Sind Sie sicher, dass Sie diese Bewertung löschen möchten?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShow(false)} color="inherit">
            Nein
          </Button>
          <Button onClick={() => deleteRatingDetail()} color="error" variant="contained">
            Ja
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Rate;
